<template>
  <SurveyCardbase>
    <template #header>
      <Avatar :picture="review.getPicture()" size="100px" />
      <section>
        <h4>{{ review.getExtraFirstname() }} {{ review.getExtraLastname() }}</h4>
        <p>{{ review.getQualification() }}</p>
      </section>
    </template>

    <template #main>
      <h5>{{ review.getDatesDisplay() }}</h5>
    </template>

    <template #footer>
      <ExtraBtnIcon
        v-if="review.isAE()"
        no-caps
        outline
        icon-name="icon-f-eye-off"
        color="primary-light"
        :btn-label="$t('CORE.BUTTONS.@IGNORE')"
        :icon-left="true"
        @click="onIgnoreReview"
      />

      <ExtraBtnIcon
        no-caps
        icon-name="icon-extra-star"
        icon-color="yellowish"
        icon-size="28px"
        unelevated
        color="primary"
        :btn-label="$t('ETAB.PAGES.REVIEW.EXTRA.@REVIEW_EXTRA')"
        @click="onOpenReview"
      />
    </template>
  </SurveyCardbase>
</template>

<script>
  import { EventManager } from "@core/managers/event.manager";
  import { ReviewExtraModel } from "@core/models";
  import { ETAB_EVENTS } from "@etab/config";
  import SurveyCardbase from "./SurveyCard.base.functional.vue";

  export default {
    components: {
      SurveyCardbase,
    },
    props: {
      review: {
        type: Object,
        default: () => new ReviewExtraModel(),
      },
    },
    methods: {
      onIgnoreReview() {
        EventManager.emit(ETAB_EVENTS.REVIEW.IGNORE_REVIEW, { review: this.review });
      },
      onExtraMissing() {
        EventManager.emit(ETAB_EVENTS.REVIEW.DECLARE_MISSING, { review: this.review });
      },
      onOpenReview() {
        EventManager.emit(ETAB_EVENTS.REVIEW.OPEN_REVIEW, { review: this.review });
      },
    },
  };
</script>
